import type { AppSelector } from "src/types";
import type { LayoutState } from "./types";

const getModel: AppSelector<LayoutState> = (state) => state.layoutModule;

export const isMobileMenuOpen: AppSelector<boolean> = (state) => getModel(state).isMobileMenuOpen;
